import { useEffect, useState } from "react";
import { autoQualityChangeLog, pingpongLog, sendFluentLog } from "../../logs";
import { useAppSelector } from "../../redux/hooks";
import { shallowEqual } from "react-redux";

const usePingPong = (qualityLevel?: number) => {
    const [qualityHistory, setQualityHistory] = useState<number[]>([]);
    const [startTimer, setStartTimer] = useState<number>(0);

    const { qualityLevels } = useAppSelector(({ controller: { qualityLevels } }) => ({ qualityLevels }), shallowEqual);

    useEffect(() => {
        if (qualityLevel) {
            let newQualityArray: number[] = [];
            switch (qualityHistory.length) {
                case 0:
                    newQualityArray = [qualityLevel];
                    break;
                case 1:
                    newQualityArray = [qualityLevel, ...qualityHistory];
                    break;
                case 2:
                    newQualityArray = [qualityLevel, ...qualityHistory];
                    sendFluentLog(
                        autoQualityChangeLog(
                            `${newQualityArray[0]}P`,
                            `${newQualityArray[1]}P`,
                            qualityLevels.indexOf(newQualityArray[0]) - qualityLevels.indexOf(newQualityArray[1])
                        )
                    );
                    break;
                default:
                    newQualityArray = [qualityLevel, qualityHistory[0], qualityHistory[1]];
                    if (newQualityArray[1] !== newQualityArray[2])
                        sendFluentLog(
                            autoQualityChangeLog(
                                `${newQualityArray[1]}P`,
                                `${newQualityArray[2]}P`,
                                qualityLevels.indexOf(newQualityArray[1]) - qualityLevels.indexOf(newQualityArray[2])
                            )
                        );
                    break;
            }
            setQualityHistory(newQualityArray);
        }
    }, [qualityLevel]);

    useEffect(() => {
        if (qualityHistory.length === 3 && qualityHistory[0] === qualityHistory[2]) {
            sendFluentLog(pingpongLog(startTimer, qualityHistory));
            setQualityHistory([]);
            setStartTimer(0);
        } else {
            setStartTimer(new Date().getTime());
        }
    }, [qualityHistory]);
};
export default usePingPong;
